export const environment = {
  production: true,
  apiBase: 'https://api.lmiriskcoach.com',
  apiKey: 'REY1OEIxMzEtRkQyQi00OTI2LTgwQkEtMTZBMEM4RUI2ODRC',
  legacyRiskCoachApiBase: 'https://classic.lmiriskcoach.com/api',
  authApiBase: 'https://lmiauth.azurewebsites.net'
};
